module.exports = __webpack_public_path__ + "img/icon-9.e6f2f353.png";